import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { EmailIcon, ToolIcon, NamingConventionsIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    heading: `Targeted messaging`,
    description: `Deliver a message that's timed and tailored to each audience, suitable for their preferred platform, and designed to influence behavior.`,
    icon: <EmailIcon />,
  },
  {
    heading: `Multichannel personalization`,
    description: `Real-time customer profiles enable the creation of dynamic audiences, allowing for seamless journeys across channels, including both paid and owned media.`,
    icon: <ToolIcon />,
  },
  {
    heading: `CustomerAI Predictions`,
    description: `Get trusted AI at your fingertips to effortlessly anticipate upcoming customer actions and create tailored campaigns without relying on data science teams.`,
    icon: <NamingConventionsIcon />,
  },
]

const copy = {
  heading: `Get a complete view of your customer`,
  description: `Understand your customer journey and unify every customer touchpoint across all platforms and channels.`,
}

export const CompleteView = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <StyledSectionCopy>
          <CopyTextBase centered={true}>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </StyledSectionCopy>
        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {features.map((feature, index) => (
              <StyledFeatureBoxBase key={index} headerPosition="top" alignment="left">
                <FeatureBox.Header>
                  <IconWrapper variant="circle" elevation={1}>
                    {feature.icon}
                  </IconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </StyledFeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-bottom: 40px;
  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    margin-bottom: 100px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;
  ${Section.Wrapper} {
    padding-top: 40px;
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 684px;
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  max-width: 336px;
  justify-self: center;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: unset;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 0 15px;
  }

  ${({ theme }) => theme.breakpoints.up(`xxl`)} {
    padding: 24px 15px;
  }
`

export default CompleteView
